var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomBorderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 9L0.00195282 2C0.00195277 0.895431 0.897383 -3.91405e-08 2.00195 -8.74228e-08L9.99975 -4.37018e-07C11.1043 -4.853e-07 11.9998 0.89543 11.9998 2L11.9998 9L9.9256 9L9.9256 3C9.92559 2.44771 9.47788 2 8.92559 2L2.88412 2C2.33184 2 1.88412 2.44772 1.88412 3L1.88412 9L0.00195312 9Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C0.895431 12 -3.91405e-08 11.1046 -8.74228e-08 10L12 10C12 11.1046 11.1046 12 10 12L2 12Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBorderIcon);
export default __webpack_public_path__ + "static/media/bottom-border-icon.6ec0eb3af968f443a3cf74317d8b0730.svg";
export { ForwardRef as ReactComponent };